import { readConfigPath } from "../../../utils/js/configMgr.js";
import { getLocationHref } from "../../../utils/js/utils.js";

/**
 * get the AdUnit string
 * @returns {string}  a string similar to "/5293/teamdogs.co.uk/puppy/stuff"
 */
export function getAdUnit() {
  const adUnitBase = readConfigPath("advertisingConfig.adUnitBaseName");
  const path = getAdUnitPathFromGlobal() || getAdUnitPathFromQueryString();

  return `${adUnitBase}${path}`;
}

/**
 * Extract the adUnit path categories from a global var
 * The name of the global comes from the config.
 * @returns {string}something like  "/category"  or  "/category/subcategory"
 */
function getAdUnitPathFromGlobal() {
  const categoryGlobal =
    window[readConfigPath("advertisingConfig.pageDataGlobalVar")] || {};
  return formatCategories((label) => categoryGlobal[label]);
}

/**
 * Extract the adUnit path categories from the query string
 * @returns {string}something like  "/category"  or  "/category/subcategory"
 */
function getAdUnitPathFromQueryString() {
  const query = new URL(getLocationHref()).searchParams;
  let path = formatCategories((label) => query.get(label));

  // special case, topdog on teamdogs
  if (path === "" && query.has("type")) {
    path = `/${query.get("type")}`;
  }
  return path;
}

/**
 * Formats some object or other data structure into a string resembling /part1/part2
 * The object containing the data must be accessible to the callback via closure.
 * The callback is used to extract first "category" then "subcategory" from the object.
 * @param {function} callback a function which will extract "category" and "subcategory" from some object in closure
 * @returns {string}
 */
function formatCategories(callback) {
  const labels = ["category", "subcategory"];
  const path = labels.reduce((acc, label) => {
    const val = callback(label);
    return acc + (val ? `/${val}` : "");
  }, "");
  return path;
}
